'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (value) {
    return value < 0 && 'number-negative' || value > 0 && 'number-positive' || '';
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/binary-utils/lib/misc/directionClassName.js
// module id = 619
// module chunks = 0